import { extend, localize } from 'vee-validate';
import veeValidateLocale from 'vee-validate/dist/locale/ja.json';
import { length, max, min, regex, required } from 'vee-validate/dist/rules';

// validate メッセージのカスタマイズと locale 指定
veeValidateLocale.messages.required = '{_field_}は必須です';
localize('ja', veeValidateLocale);

// カスタム validator
export default (): void => {
  extend('max', max);
  extend('min', min);
  extend('length', length);
  extend('regex', regex);
  extend('required', required);
};
